export const version = '0.785.0'
export const chameleonWebVersion = '9.13.0'
export const chameleonCoreVersion = '7.9.1'
